import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import { setNodeData } from '../../../features/mainSlice';
import Dropdown from '../../shared/Dropdown';

const useStyles = makeStyles(
  () => ({
    name: {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: '12px',
    },
    block: {
      borderRadius: 24,
      backgroundColor: '#F9F9F9',
      padding: '12px 16px',
    },
    error: {
      border: `1px solid ${color.$17}`,
    },
  }),
  {
    name: 'Coupon',
  },
);

const Coupon = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode, isErrorNodeIds } = useSelector(state => state.ma);
  const { couponList } = useSelector(state => state.superMarket);
  const { couponId } = selectedNode?.data;
  const isError = !!~isErrorNodeIds.indexOf(selectedNode?.id);

  const onCouponSetIdChange = (v, item) => {
    dispatch(setNodeData({ couponId: item?.value, couponName: item?.text }));
  };

  return (
    <div>
      <div className={classes.name}>{t('coupon.title')}</div>
      <div className={classes.block}>
        <Dropdown
          placeholder={t('coupon.couponPlaceholder')}
          menuItems={couponList.map(c => ({
            text: c?.couponName,
            value: c?.couponSetId,
          }))}
          value={couponId || undefined}
          onChange={onCouponSetIdChange}
          className={classnames({
            [classes.error]: isError && !couponId,
          })}
        />
      </div>
    </div>
  );
};

export default Coupon;
